import dayjs from 'dayjs'

export const BACKEND_MAX_FILE_SIZE_MB = 150

export const formatFileSize = (value?: number) => {
  if (!value) return '—'
  if (value < 1024) return `${value} Б`
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} КБ`
  return `${(value / (1024 * 1024)).toFixed(1)} МБ`
}

export const toExcelRowNumber = (rowIndex: number) => rowIndex + 1

export const parseExtractedQuantity = (value?: string) => {
  const normalized = value?.replace(/\s/g, '').replace(',', '.')
  if (!normalized) return null

  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : null
}

const CHECKS_RESET_FORMAT = 'DD.MM.YYYY HH:mm'

export const formatChecksResetAt = (value: string) =>
  `История проверок сброшена ${dayjs(value).format(CHECKS_RESET_FORMAT)}`
